import { useSyncExternalStore } from 'react';

const isBrowser = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

const getServerDefaultMatches = (
  query: string,
  defaultMatches?: boolean,
) => {
  if (typeof defaultMatches === 'boolean') return defaultMatches;

  const normalizedQuery = query.toLowerCase();

  if (normalizedQuery.includes('min-width')) return true;
  if (normalizedQuery.includes('max-width')) return false;

  return false;
};

const useMediaQuery = (query: string, defaultMatches?: boolean) => {
  const serverDefaultMatches = getServerDefaultMatches(query, defaultMatches);

  return useSyncExternalStore(
    (onStoreChange) => {
      if (!isBrowser()) {
        return () => {};
      }

      const mediaMatch = window.matchMedia(query);
      mediaMatch.addEventListener('change', onStoreChange);

      return () => mediaMatch.removeEventListener('change', onStoreChange);
    },
    () =>
      isBrowser() ? window.matchMedia(query).matches : serverDefaultMatches,
    () => serverDefaultMatches,
  );
};

export default useMediaQuery;
